module.exports = __webpack_public_path__ + "img/general.305be4af.svg";